import { style } from 'styled-system';

export const flexBasis = style({
  prop: 'span',
  alias: 'columnWidth',
  cssProperty: 'flex',
  transformValue: (n: number) => `0 0 ${n * (100 / 24)}%`,
});
